
import {setBearerToken, getBearerToken} from '@/http'

export default async (to, from, next) => {

   const path = `${to.path}`.split("/");
  
   switch(path[1]){
      case "empresa":

         if(path[2] == "token"){
            
            var accessToken = `${window.location.hash}`.split("=")[1]
               
            var token = {
               access_token: accessToken,
            }
            localStorage.setItem('companyToken',JSON.stringify(token));
            setBearerToken(accessToken)
            
            return next({
               name:"companyDashboard"
            })

         }
        
         var getToken = getBearerToken("companyToken")
         if(getToken != undefined){
            setBearerToken(getToken.access_token)
            return  next()
         }

         return next({
            name:"login"
         }) 
          
   }
    
   next()
}


 